export enum SensorSource {
  external = "external_history",
  forecast = "external_forecast",
  device = "device",
  mixed = "mixed",
}
